import React from 'react'
import styled from 'styled-components'
import { InvestmentTitleText } from 'src/components/Global/Text/TitleText'
import { TransactionListHeading } from './TransactionListHeading'
const Wrapper = styled.div`
  padding: 55px 0px;
  width: 95%;
  margin-right: 20px;
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    margin-right: 0px;
  }
`
const Transaction = () => {
  return (
    <Wrapper>
      <InvestmentTitleText>Transactions</InvestmentTitleText>
      <TransactionListHeading />
    </Wrapper>
  )
}

export { Transaction }
